import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './about.css'

const About = (props) => {
  return (
    <div className="about-container10">
      <Helmet>
        <title>About Vlad Butucariu - Senior Product Designer</title>
        <meta
          name="description"
          content="About senior product designer Vlad Butucariu: product strategy, UX/UI, design systems, and AI-native prototyping for complex digital products."
        />
        <meta
          property="og:title"
          content="About Vlad Butucariu - Senior Product Designer"
        />
        <meta
          property="og:description"
          content="Product designer, systems thinker, and AI-native prototyper based in Rotterdam."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/about" />
        <meta property="og:url" content="https://vladbutucariu.com/about" />
      </Helmet>
      <div className="about-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="about-thq-top-section-elm">
          <div className="about-thq-video-div-elm1">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="about-video1"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="about-video2"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="about-thq-video-mobile-elm1"
            ></video>
          </div>
          <div className="about-thq-video-div-elm2">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="about-video3"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="about-thq-video-mobile-elm2"
            ></video>
          </div>
          <div className="about-thq-section-elm">
            <div className="about-thq-color-wrapper-elm">
              <div className="about-container11">
                <div className="about-container12">
                  <div className="about-container13">
                    <h1 className="about-text10 header-project">// ABOUT_VLAD</h1>
                    <div className="about-container14">
                      <span className="about-text11">senior product designer</span>
                      <span className="about-text12">Rotterdam, NL</span>
                    </div>
                  </div>
                </div>
                <div className="about-container15">
                  <div className="about-container16">
                    <h2 className="about-text13">
                      Product designer. Systems thinker. AI native.
                    </h2>
                    <span className="about-text14">
                      <span>
                        I&apos;m Vlad Butucariu, a senior product designer with
                        more than fifteen years of experience across product
                        design, UX/UI, visual identity, and digital systems.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        I work best on technically complex products that need to
                        feel clear, coherent, and usable. My role often spans
                        product definition, interaction design, visual
                        direction, prototyping, and close collaboration with
                        engineering.
                      </span>
                    </span>
                  </div>
                  <div className="about-container17">
                    <h2 className="about-text19">
                      <span>Making Complexity Usable</span>
                      <br></br>
                    </h2>
                    <span className="about-text22">
                      <span>
                        My approach starts with understanding the product,
                        constraints, and people using it. I reduce complicated
                        workflows into understandable structures, then build a
                        visual language that can scale with the product.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        Web3 is one of the technical domains I know deeply, not
                        the limit of my work. The same design principles apply
                        to AI tools, platforms, applications, and other complex
                        digital products: make the logic visible, the actions
                        predictable, and the system consistent.
                      </span>
                    </span>
                  </div>
                  <div className="about-container18">
                    <h2 className="about-text27">
                      From Design to Working Software
                    </h2>
                    <span className="about-text28">
                      <span>
                        My background in graphic design and design education
                        shaped a strong foundation in typography, systems, and
                        visual craft. Product work added research, interaction,
                        prototyping, and the discipline of designing alongside
                        technical teams.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        Today I use AI-native workflows with Claude Code, Codex,
                        and related tools to move from high-fidelity design to
                        functional prototypes and production-ready systems much
                        faster. The goal is not automation for its own sake, but
                        better feedback, clearer decisions, and less distance
                        between an idea and a working product.
                      </span>
                    </span>
                  </div>
                  <div className="about-container19">
                    <h2 className="about-text33">
                      <span>Open to Roles and Collaborations</span>
                      <br></br>
                    </h2>
                    <span className="about-text36">
                      <span>
                        Based in Rotterdam, I&apos;m open to senior product design
                        roles in the Netherlands or remote across Europe, as
                        well as selected collaborations on ambitious digital
                        products.
                      </span>
                      <br></br>
                    </span>
                    <span className="about-text39">
                      <span>[</span>
                      <a
                        href="mailto:vlad@irreversible.cc?subject=Hi Vlad"
                        className="about-link2"
                      >
                        Get in Touch
                      </a>
                      <span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>]</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default About
